import React from 'react'
import moment from 'moment'
import Button from '../../../../components/Button'
import { Checkbox } from '../../../../components/ModalInputs'
import styles from '../styles.module.scss'

const ModalFooter = ({
  event,
  onSave,
  onClose,
  showValue,
  onShowChange,
  showCheckbox = true
}) => {
  const createInfo = event?.whocreate_fio
    ? `${event.whocreate_fio} ${moment(event.whencreate).format('DD.MM.YYYY HH:mm')}`
    : ''
  const changeInfo = event?.whochange_fio
    ? `${event.whochange_fio} ${moment(event.whenchange).format('DD.MM.YYYY HH:mm')}`
    : ''

  return (
    <div className={styles.modalFooter}>
      <div>
        {createInfo && <div>Создал: {createInfo}</div>}
        {changeInfo && <div>Изменил: {changeInfo}</div>}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', alignItems: 'center' }}>
        {showCheckbox && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              name='show'
              checked={showValue}
              onChange={onShowChange}
            />
            <label htmlFor="show" style={{ marginLeft: '5px', color: 'white' }}>отображать</label>
          </div>
        )}
        <Button mode='white' onClick={onSave}>Сохранить</Button>
        <Button mode='white' onClick={onClose}>Закрыть</Button>
      </div>
    </div>
  )
}

export default ModalFooter
